module.exports = __webpack_public_path__ + "static/img/new02.cbafd8e3.png";